// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mat-column-copy {
  width: 50px;
  flex: none;
  padding-left: 10px;
}

.mat-column-generatedDate {
  width: 80px;
  flex: none;
  font-size: 12px;
  justify-content: center;
}

.mat-column-expirationDate {
  width: 80px;
  flex: none;
  font-size: 12px;
  justify-content: center;
}

.mat-column-createdBy {
  width: 150px;
  flex: none;
  font-size: 12px;
  justify-content: center;
}

.mat-column-channels {
  font-size: 12px;
}

.mat-column-comments {
  font-size: 12px;
  padding-right: 10px;
}

.overlay-spinner-container {
  z-index: 1000;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/job/dialogs/job-links-dialog/job-links-dialog.component.scss"],"names":[],"mappings":"AACA;EACC,WAAA;EACA,UAAA;EACA,kBAAA;AAAD;;AAGA;EACC,WAAA;EACA,UAAA;EACA,eAAA;EACA,uBAAA;AAAD;;AAGA;EACC,WAAA;EACA,UAAA;EACA,eAAA;EACA,uBAAA;AAAD;;AAGA;EACC,YAAA;EACA,UAAA;EACA,eAAA;EACA,uBAAA;AAAD;;AAGA;EACC,eAAA;AAAD;;AAGA;EACC,eAAA;EACA,mBAAA;AAAD;;AAGA;EACC,aAAA;AAAD","sourcesContent":["\n.mat-column-copy {\n\twidth: 50px;\n\tflex: none;\n\tpadding-left: 10px;\n}\n\n.mat-column-generatedDate {\n\twidth: 80px;\n\tflex: none;\n\tfont-size: 12px;\n\tjustify-content: center;\n}\n\n.mat-column-expirationDate {\n\twidth: 80px;\n\tflex: none;\n\tfont-size: 12px;\n\tjustify-content: center;\n}\n\n.mat-column-createdBy {\n\twidth: 150px;\n\tflex: none;\n\tfont-size: 12px;\n\tjustify-content: center;\n}\n\n.mat-column-channels {\n\tfont-size: 12px;\n}\n\n.mat-column-comments {\n\tfont-size: 12px;\n\tpadding-right: 10px;\n}\n\n.overlay-spinner-container {\n\tz-index: 1000;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
